import WalletReportLayout from 'container/WalletReportLayout'
import React from 'react'

const Wallet: React.FC = () => {
	return <WalletReportLayout />
}

export default Wallet
